<template>
  <!-- 宣讲行程页 -->
  <div class="Lecture_itinerary">
    <!-- <van-nav-bar
      :title="title"
      :fixed="true"
      left-arrow
      @click-left="onClickLeft"
    >
    </van-nav-bar> -->
    <div class="content">
      <div class="search_box">
        <div class="left">
          <van-field readonly
                     clickable
                     v-model="actype"
                     placeholder="选择活动类别"
                     right-icon="arrow-down"
                     @click="showActypePicker = true" />
        </div>
        <van-search v-model="value"
                    shape="round"
                    placeholder="关键词" />
      </div>
      <div class="itinerary_box">
        <ul class="card_ul">
          <li class="card_li"
              v-for="(item, idx) in zpAcListRs"
              :key="idx + 'le'"
              @click="gotoPage(item)">
            <div class="left">
              <img src="@/assets/img/home_hd_01.png"
                   alt="" />
            </div>
            <div class="right">
              <div class="qdname">{{ item.qdname }}</div>
              <div class="time">{{ item.bd }}</div>
              <div class="addr">{{ item.acaddr }}</div>
            </div>
          </li>
        </ul>
        <van-empty v-if="zpAcList.length == 0"
                   image="search"
                   description="暂无数据" />
      </div>
    </div>
    <!-- 计产类别下拉弹窗 -->
    <van-popup v-model="showActypePicker"
               round
               position="bottom">
      <van-picker show-toolbar
                  :columns="ActypeColumns"
                  value-key="name"
                  @cancel="showActypePicker = false"
                  @confirm="onConfirmAc" />
    </van-popup>
  </div>
</template>

<script>
import { getZpAcList, getScanEntryHomeSet } from '@/request/api.js'
export default {
  data () {
    let title = this.$route.query.title || ''
    return {
      title,
      actype: '进行中',
      actypeid: 1,
      value: '',
      showActypePicker: false,
      ActypeColumns: [
        { name: '未进行', code: 0 },
        { name: '进行中', code: 1 },
        { name: '已结束', code: 2 }
      ],
      zpAcList: []
    }
  },
  computed: {
    zpAcListRs () {
      if (this.value)
      {
        return this.zpAcList.filter(e => {
          const qdname = e.qdname ? e.qdname : ''
          const acaddr = e.acaddr ? e.acaddr : ''
          return (
            qdname.indexOf(this.value) > -1 || acaddr.indexOf(this.value) > -1
          )
        })
      } else
      {
        return this.zpAcList
      }
    }
  },
  created () {
    this.getZpAcListData()
    // 获取参数
    getScanEntryHomeSet().then(res => {
      const data = res.data[0]
      // 修改页面标题
      document.title = data.home_m_title
    })
  },
  methods: {
    onClickLeft () {
      this.$router.push('/home')
    },
    // 选择计产类别回调
    onConfirmAc (value) {
      this.actype = value.name
      this.actypeid = value.code
      this.showActypePicker = false
      this.getZpAcListData()
    },
    // 获取招聘活动列表
    getZpAcListData () {
      getZpAcList({
        actypeid: this.actypeid
      }).then(res => {
        this.zpAcList = res.data
      })
    },
    // goto去详情页
    gotoPage (item) {
      localStorage.setItem('lectureDetail', JSON.stringify(item))
      this.$router.push({
        path: '/lectureDetail',
        query: { title: this.title }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.Lecture_itinerary {
  height: 100vh;
  background-color: #e9eaec;
  overflow: hidden;
  .van-nav-bar {
    height: 92px;
    background: #bcdfff;
    /deep/ .van-nav-bar__left {
      .van-icon {
        color: #333;
      }
    }
    /deep/.van-nav-bar__title {
      color: #333;
      font-size: 36px;
      font-weight: bold;
      font-family: Source Han Sans CN;
    }
  }
  .van-hairline--bottom::after {
    border: 0;
  }
  .content {
    height: 100%;
    // height: calc(100% - 92px);
    // margin-top: 92px;
    // overflow-y: auto;
    .search_box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 100px;
      .left {
        width: 30%;
        height: 100%;
        .van-cell {
          height: 100%;
          padding: 10px 20px;
          /deep/.van-cell__value {
            .van-field__body {
              height: 100%;
            }
          }
        }
      }
      .van-search {
        flex: 1;
        height: 100%;
      }
    }
    .itinerary_box {
      height: calc(100% - 100px);
      // margin-top: 92px;
      overflow-y: auto;
      .card_ul {
        margin: 20px;
      }
      .card_li {
        height: 280px;
        padding: 20px;
        background: #ffffff;
        border-radius: 10px;
        display: flex;
        align-items: center;
        .left {
          width: 35%;
          margin-right: 40px;
          display: flex;
          align-items: center;
          img {
            width: 100%;
          }
        }
        .right {
          flex: 1;
          display: flex;
          flex-direction: column;
          height: 100%;
          justify-content: space-evenly;
          .qdname {
            font-size: 32px;
            color: #303030;
            font-weight: bold;
          }
          .time,
          .addr {
            font-size: 28px;
            color: #909090;
          }
        }
      }
      .card_li:not(:last-child) {
        margin-bottom: 20px;
      }
    }
  }
}
</style>
